import { render, staticRenderFns } from "./submitlist.vue?vue&type=template&id=09632dce&scoped=true&"
import script from "./submitlist.vue?vue&type=script&lang=js&"
export * from "./submitlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09632dce",
  null
  
)

export default component.exports